module.exports = __webpack_public_path__ + "static/media/fdg-sace.c83e2de2.png";